import { BrowserRouter as Router } from 'react-router-dom';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

import { AppTranslations } from '../app-translations';
import theme from '../../../themes/default';
import { AppSettingsProps } from './app-settings.models';
import { LocaleProvider } from '../../../context';
import '../../../fonts';

export const AppSettings = ({ children }: AppSettingsProps) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <LocaleProvider>
        <AppTranslations>
          <Router>
            <CssBaseline />
            {children}
          </Router>
        </AppTranslations>
      </LocaleProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);
